// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Env = require("../../../../reason/common/Env.bs.js");
var React = require("react");
var Stripe = require("../../../../reason/stripe/Stripe.bs.js");
var ButtonsV5 = require("../../atoms/Buttons/ButtonsV5.bs.js");
var Responsive = require("../../helpers/Responsive.bs.js");
var View__Jsx3 = require("../../helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../atoms/Form/Form__Input.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Stripe__Components = require("../../atoms/Stripe/Stripe__Components.bs.js");
var InlineWarning__Jsx3 = require("../../atoms/InlineWarning/InlineWarning__Jsx3.bs.js");
var Colors = require("uikit/styles/colors");

var amex = (require('../../../../../assets/images/amex.svg'));

var discover = (require('../../../../../assets/images/discover.svg'));

var mastercard = (require('../../../../../assets/images/mastercard.svg'));

var visa = (require('../../../../../assets/images/visa.svg'));

function PaymentForm__Jsx3$CCImage(props) {
  return JsxRuntime.jsx(View__Jsx3.View.make, {
              ml: props.ml,
              width: Responsive.make({
                    NAME: "px",
                    VAL: 60
                  }, {
                    NAME: "px",
                    VAL: 66
                  }, undefined, undefined, undefined, undefined, undefined),
              children: Caml_option.some(JsxRuntime.jsx("img", {
                        style: {
                          backgroundImage: "linear-gradient(180deg, #FFFFFF 0%, #EAEAEA 100%)",
                          border: "1px solid " + Colors.gallery,
                          overflow: "hidden",
                          borderRadius: "4px"
                        },
                        src: props.src
                      }))
            });
}

var CCImage = {
  amex: amex,
  discover: discover,
  mastercard: mastercard,
  visa: visa,
  make: PaymentForm__Jsx3$CCImage
};

function PaymentForm__Jsx3$FormWithoutElements(props) {
  var onToken = props.onToken;
  var stripe = Stripe.React.useStripe();
  var elements = Stripe.React.useElements();
  var match = React.useReducer((function (state, action) {
          switch (action.TAG) {
            case "SetName" :
                return {
                        name: action._0,
                        cardNumberValid: state.cardNumberValid,
                        cardExpiryValid: state.cardExpiryValid,
                        cardCVCValid: state.cardCVCValid,
                        status: state.status
                      };
            case "SetCardNumberValidation" :
                return {
                        name: state.name,
                        cardNumberValid: action._0,
                        cardExpiryValid: state.cardExpiryValid,
                        cardCVCValid: state.cardCVCValid,
                        status: state.status
                      };
            case "SetCardExpiryValidation" :
                return {
                        name: state.name,
                        cardNumberValid: state.cardNumberValid,
                        cardExpiryValid: action._0,
                        cardCVCValid: state.cardCVCValid,
                        status: state.status
                      };
            case "SetCardCVCValidation" :
                return {
                        name: state.name,
                        cardNumberValid: state.cardNumberValid,
                        cardExpiryValid: state.cardExpiryValid,
                        cardCVCValid: action._0,
                        status: state.status
                      };
            case "SetStatus" :
                return {
                        name: state.name,
                        cardNumberValid: state.cardNumberValid,
                        cardExpiryValid: state.cardExpiryValid,
                        cardCVCValid: state.cardCVCValid,
                        status: action._0
                      };
            
          }
        }), {
        name: "",
        cardNumberValid: false,
        cardExpiryValid: false,
        cardCVCValid: false,
        status: "NotAsked"
      });
  var dispatch = match[1];
  var state = match[0];
  var onCardNumberValidationChange = React.useCallback((function (isValid) {
          dispatch({
                TAG: "SetCardNumberValidation",
                _0: isValid
              });
        }), [dispatch]);
  var onCardExpiryValidationChange = React.useCallback((function (isValid) {
          dispatch({
                TAG: "SetCardExpiryValidation",
                _0: isValid
              });
        }), [dispatch]);
  var onCardCVCValidationChange = React.useCallback((function (isValid) {
          dispatch({
                TAG: "SetCardCVCValidation",
                _0: isValid
              });
        }), [dispatch]);
  var handleSubmit = function (e) {
    e.preventDefault();
    if (elements === undefined) {
      return ;
    }
    if (stripe === undefined) {
      return ;
    }
    var card = Stripe.React.Elements.getCardElement(Caml_option.valFromOption(elements), "cardNumber");
    dispatch({
          TAG: "SetStatus",
          _0: "Loading"
        });
    Stripe.API.createToken(Caml_option.valFromOption(stripe), card, {
            name: state.name
          }).then(function (x) {
          if (x.TAG === "Ok") {
            return onToken(x._0).then(function (status) {
                        dispatch({
                              TAG: "SetStatus",
                              _0: status
                            });
                      });
          }
          var error_1 = x._0.message;
          var error = {
            NAME: "CreateTokenError",
            VAL: error_1
          };
          return Promise.resolve(dispatch({
                          TAG: "SetStatus",
                          _0: error
                        }));
        });
  };
  var match$1 = state.status;
  var tmp;
  if (typeof match$1 === "object") {
    var variant = match$1.NAME;
    tmp = variant === "CreateTokenError" || variant === "Error" || variant === "PaymentError" ? JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(InlineWarning__Jsx3.make, {
                  children: JsxRuntime.jsx(JsxRuntime.Fragment, {
                        children: Caml_option.some(match$1.VAL)
                      })
                }),
            className: "mb-4"
          }) : null;
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("form", {
                    children: [
                      tmp,
                      JsxRuntime.jsx("h6", {
                            children: "Accepted payment types",
                            className: "font-semibold text-gray-700 mb-2"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(PaymentForm__Jsx3$CCImage, {
                                    src: visa
                                  }),
                              JsxRuntime.jsx(PaymentForm__Jsx3$CCImage, {
                                    src: mastercard
                                  }),
                              JsxRuntime.jsx(PaymentForm__Jsx3$CCImage, {
                                    src: amex
                                  }),
                              JsxRuntime.jsx(PaymentForm__Jsx3$CCImage, {
                                    src: discover
                                  })
                            ],
                            className: "flex justify-between items-center mb-4 gap-1 md:gap-2"
                          }),
                      JsxRuntime.jsx(Stripe__Components.CardNumberElement.make, {
                            placeholder: "0000 0000 0000 0000",
                            labelText: "Card number",
                            onValidationChange: onCardNumberValidationChange
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(Stripe__Components.CardExpiryElement.make, {
                                          labelText: "Expiration date",
                                          onValidationChange: onCardExpiryValidationChange
                                        }),
                                    className: "w-[47%]"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(Stripe__Components.CardCVCElement.make, {
                                          labelText: "Security code",
                                          onValidationChange: onCardCVCValidationChange
                                        }),
                                    className: "w-[47%]"
                                  })
                            ],
                            className: "my-4 flex flex-row justify-between"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(Form__Input.make, {
                                  labelText: "Name on Card",
                                  placeholderText: "John Smith",
                                  onChange: (function (e) {
                                      dispatch({
                                            TAG: "SetName",
                                            _0: e.target.value
                                          });
                                    }),
                                  value: state.name
                                }),
                            className: "mb-8"
                          }),
                      JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                            disabled: !(state.cardNumberValid && state.cardExpiryValid && state.cardCVCValid && state.name !== "") || state.status === "Loading",
                            size: "huge",
                            className: "w-full",
                            children: Caml_option.some(JsxRuntime.jsx("div", {
                                      children: props.buttonText,
                                      className: "flex justify-center"
                                    }))
                          })
                    ],
                    onSubmit: handleSubmit
                  })
            });
}

var FormWithoutElements = {
  make: PaymentForm__Jsx3$FormWithoutElements
};

var stripe = Stripe.loadStripe(Env.stripe_key);

function PaymentForm__Jsx3$Form(props) {
  return JsxRuntime.jsx(Stripe.React.Elements.make, {
              stripe: stripe,
              children: JsxRuntime.jsx(PaymentForm__Jsx3$FormWithoutElements, {
                    buttonText: props.buttonText,
                    onToken: props.onToken
                  })
            });
}

var Form = {
  make: PaymentForm__Jsx3$Form
};

var Heading;

var responsive = Responsive.make;

var View;

var InlineWarning;

exports.Heading = Heading;
exports.responsive = responsive;
exports.View = View;
exports.InlineWarning = InlineWarning;
exports.CCImage = CCImage;
exports.FormWithoutElements = FormWithoutElements;
exports.stripe = stripe;
exports.Form = Form;
/* amex Not a pure module */
